import React, { useMemo } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { useTranslation } from "react-i18next";
import { useUserContext } from "context/UserContext";

const APPSMITH_INVOICE_BASE_URL =
  "https://app.appsmith.com/app/untitled-application-1/page1-687b19dc263c1d7f9e7c9c8f";

function InvoicesCM() {
  const { t } = useTranslation("common");
  const { userData } = useUserContext() || {};
  const email = userData?.email ? userData.email.trim() : "";

  const iframeUrl = useMemo(() => {
    const params = new URLSearchParams({
      embed: "true",
      hide_navigation_bar: "true",
      role: "CM",
    });
    if (email) {
      params.set("email", email);
    }
    return `${APPSMITH_INVOICE_BASE_URL}?${params.toString()}`;
  }, [email]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  {t("pageTitles.invoices")}
                </MDTypography>
              </MDBox>
              <MDBox pt={3} px={0} width="100%">
                <iframe
                  src={iframeUrl}
                  width="100%"
                  height="800px"
                  frameBorder="0"
                  title="Appsmith Invoice CM"
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default InvoicesCM;
